import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function PaymentCancel() {
  return (
    <div className="relative z-10 pt-40 pb-32 max-w-2xl mx-auto px-6 text-center" data-testid="payment-cancel-page">
      <XCircle size={64} className="mx-auto text-muted-foreground mb-8" strokeWidth={1.2} />
      <h1 className="font-serif text-5xl md:text-6xl font-light mb-6">Pagamento annullato</h1>
      <p className="text-lg text-muted-foreground mb-10">Nessun addebito è stato effettuato. Il tuo scrigno ti aspetta ancora.</p>
      <Link to="/checkout"><Button className="rounded-full bg-gold hover:bg-gold/90 text-white h-12 px-8" data-testid="retry-checkout-btn">Riprova il pagamento</Button></Link>
    </div>
  );
}
